import Model from './model.js';

class Globals extends Model {
  constructor() {
    super({
      data: {},
      defaults: {}
    });
    this.set('Relay', new EventTarget());
  }
};

export default new Globals();